angular.module('picmonicng').controller('EditorController', [
  '$q',
  '$scope',
  '$filter',
  '$stateParams',
  'hotkeys',
  'resolvedData',
  'ClassificationService',
  'EditorService',
  'UserService',
  'PermissionsService',
  '$timeout',
  'toaster',
  'WorkflowService',
  'User',
  'AudioService',
  '$window',
  'Picmonics',
  '$modal',
  'Upload',
  'SalesforceChatService',
  function (
    $q,
    $scope,
    $filter,
    $stateParams,
    hotkeys,
    resolvedData,
    ClassificationService,
    EditorService,
    UserService,
    PermissionsService,
    $timeout,
    toaster,
    WorkflowService,
    User,
    AudioService,
    $window,
    Picmonics,
    $modal,
    Upload,
    SalesforceChatService
  ) {
    $scope.EditorService = EditorService;
    $scope.AudioService = AudioService;
    $scope.UserService = UserService;
    $scope.WorkflowService = WorkflowService;
    $scope.ClassificationService = ClassificationService;
    $scope.PermissionsService = PermissionsService;
    $scope.input = {};

    $scope.froalaOptionsTextArea = {
      key: 'LB-22encg1C-8xqA2wzA-13==',
      inlineMode: true,
      buttons: ['bold', 'italic', 'underline', 'subscript', 'superscript'],
      editorClass: 'pls-input--froala-area',
      paragraphy: false,
      spellcheck: true,
    };

    PermissionsService.roles.$promise.then(function () {
      if (PermissionsService.hasRole('workflow').result) {
        $scope.froalaOptionsTextArea.buttons.push('createLink');
      }
    });

    $scope.froalaOptionsText = {
      key: 'LB-22encg1C-8xqA2wzA-13==',
      inlineMode: true,
      buttons: ['bold', 'italic', 'underline', 'subscript', 'superscript', 'insertUnorderedList'],
      editorClass: 'pls-input--froala',
      multiLine: false,
      paragraphy: false,
      spellcheck: true,
    };

    if (!UserService.user.user_id) {
      var redirect = location.pathname;
      window.onbeforeunload = null;
      window.location = '/login?redirect=' + encodeURIComponent(redirect);
    }

    var start = Date.now();

    $scope.$stateParams = $stateParams;
    //$scope.canGenerate = PermissionsService.hasAccess('admin', 'access_editor');

    EditorService.reset();
    EditorService.init(resolvedData);
    // Advise the editor service where & when to return
    if ($scope.$stateParams.returnTo) {
      EditorService.setReturnTo($scope.$stateParams.returnTo, $scope.$stateParams.returnAfterFact ? true : false);
    }

    // If a connection to pusher's presence has been established, add the members object to the editor service.
    if (resolvedData.pusherConnection) {
      EditorService.editingMembers = resolvedData.pusherConnection.members;

      resolvedData.pusherConnection.memberAdded(function (data) {
        EditorService.editingMembers = resolvedData.pusherConnection.members;
        toaster.info('', data.info.first_name + ' is now waiting to edit this Picmonic.');
      });

      resolvedData.pusherConnection.memberRemoved(function (data) {
        if (
          $filter('arrayPos')($filter('orderBy')(EditorService.editingMembers, 'joined_at'), data.id, 'user_id') == 0
        ) {
          EditorService.refresh().then(function () {
            EditorService.editingMembers = resolvedData.pusherConnection.members;
          });
        } else {
          EditorService.editingMembers = resolvedData.pusherConnection.members;
        }
      });

      $scope.$on('$stateChangeStart', function () {
        resolvedData.pusherConnection.unsubscribe();
      });
    }

    $scope.autoPopulateCharacters = function ($item) {
      var name = typeof $item === 'object' ? $item.picmonic : $item;
      if (name === 'header') {
        name = '';
      }
      if (typeof $item === 'object') {
        if (EditorService.tab == 'topic') {
          EditorService.primaryFact().picmonic = name;
        } else {
          EditorService.currentFact().picmonic = name;
        }
      }

      EditorService.searchAssets('images', name);
    };

    $scope.addDistractor = function ($item) {
      var name = typeof $item === 'object' ? $item.display_name : $item;
      var fact = EditorService.currentFact();
      fact.createDistractor = '';
      if (fact.display_name === name) {
        return;
      }
      if (fact.distractor_names) {
        if (fact.distractor_names.indexOf(name) > -1) {
          return;
        }
        fact.distractor_names.push(name);
      } else {
        fact.distractor_names = [name];
      }
    };

    var tab;

    if (EditorService.hasAccess('workflow', 'topic_tab', EditorService.currentCard)) {
      tab = 'topic';

      if ($stateParams.tab) {
        tab = $stateParams.tab;
      }
    } else {
      tab = 'fact';

      var allowedTabs = ['fact'];

      if (allowedTabs.indexOf($stateParams.tab) > -1) {
        tab = $stateParams.tab;
      }
    }

    EditorService.selectTab(tab);

    switch (tab) {
      case 'fact':
        if ($stateParams.newFact) {
          EditorService.createNewFact($stateParams.newFact);
          $scope.autoPopulateCharacters($stateParams.newFact);
        } else if ($stateParams.selectedFactId) {
          fact = $filter('filter')(EditorService.currentFacts, {
            fact_id: $stateParams.selectedFactId,
          });
          if (fact[0]) {
            EditorService.selectFact(fact[0]);
          }
        }
        break;
      case 'topic':
        if ($stateParams.first_viewing && !EditorService.primaryFact().characters.length) {
          EditorService.searchAssets('images', EditorService.primaryFact().name);
        }
        break;
    }

    $scope.factAutoSuggestResults = { results: [] };
    $scope.createFact = function (item) {
      // If the user entered a fact but didn't click a result from the auto suggest and it exactly matches a result from the auto suggest then select it for the user
      // This section logic is duplicated in learn.js createFact
      if (!item && $scope.input.fact && $scope.factAutoSuggestResults.results.length) {
        angular.forEach($scope.factAutoSuggestResults.results, function (result) {
          if (result.name.toLowerCase() === $scope.input.fact.toLowerCase()) {
            item = result;
          }
        });
      }

      if (item) {
        EditorService.createNewFact(item.name);
        $scope.autoPopulateCharacters(item);
      } else if ($scope.input.fact) {
        EditorService.createNewFact($scope.input.fact);
        $scope.autoPopulateCharacters($scope.input.fact);
      }

      $scope.input.fact = '';
      $timeout(function () {
        $('.fact-editor-wrapper .fact-classifier-clickable').focus();
      }, 0);
    };

    $scope.createHeader = function (item) {
      if (item) {
        EditorService.createNewFact({ header: 1, name: item.name });
      } else if ($scope.input.header) {
        EditorService.createNewFact({
          header: 1,
          name: $scope.input.header,
        });
      }
      $scope.input.header = '';
    };

    $scope.userFactDragListener = {
      orderChanged: function (event) {
        EditorService.moveFact(event.source.itemScope.fact, event.dest.index);
      },
      accept: function (source, dest) {
        return source.itemScope.sortableScope.options.containment == dest.options.containment;
      },
      containment: '.my-fact-wrapper',
    };

    $scope.factDragListener = {
      orderChanged: function (event) {
        EditorService.moveFact(event.source.itemScope.fact, event.dest.index);
      },
      accept: function (source, dest) {
        return source.itemScope.sortableScope.options.containment == dest.options.containment;
      },
      containment: '.fact-list-wrapper',
    };
    var tabs = ['topic', 'background', 'category', 'fact', 'audio'];

    hotkeys
      .bindTo($scope)
      .add({
        combo: ['ctrl+z', 'command+z'],
        callback: function () {
          EditorService.undo();
        },
      })
      .add({
        combo: ['ctrl+up', 'command+up'],
        description: 'cycle through the tabs',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (e) {
          e.preventDefault();
          EditorService.selectTab(tabs[(tabs.indexOf(EditorService.tab) + 4) % 5]);
        },
      })
      .add({
        combo: ['ctrl+down', 'command+down'],
        description: 'cycle through the tabs',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (e) {
          e.preventDefault();
          EditorService.selectTab(tabs[(tabs.indexOf(EditorService.tab) + 1) % 5]);
        },
      })
      /*
      .add({
        combo: ["ctrl+right", "command+right"],
        description: "go to fact question panel",
        allowIn: ["INPUT", "SELECT", "TEXTAREA"],
        callback: function (e) {
          e.preventDefault();
          EditorService.tab === "fact" &&
            EditorService.currentFact() &&
            EditorService.selectSubtab("question");
        },
      })
      .add({
        combo: ["ctrl+left", "command+left"],
        description: "go to edit fact panel",
        allowIn: ["INPUT", "SELECT", "TEXTAREA"],
        callback: function (e) {
          e.preventDefault();
          EditorService.tab === "fact" &&
            EditorService.currentFact() &&
            EditorService.selectSubtab("fact");
        },
      })
      */
      .add({
        combo: ['ctrl+shift+down', 'command+shift+down'],
        description: 'go to next fact',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (e) {
          e.preventDefault();
          EditorService.tab === 'fact' && EditorService.nextFact();
        },
      })
      .add({
        combo: ['ctrl+shift+d', 'command+shift+d'],
        description: 'add random suggested distractors',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (e) {
          e.preventDefault();
          EditorService.tab === 'fact' && EditorService.currentFact() && EditorService.addRandomSuggestedDistractors();
        },
      })
      .add({
        combo: ['ctrl+/', 'command+/'],
        description: 'add quiz question template',
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (e) {
          e.preventDefault();
          if (EditorService.tab === 'fact' && EditorService.currentFact()) {
            EditorService.currentFact().question_text =
              'Which of the following is most likely associated with ' + EditorService.currentFact().display_name + '?';
          }
        },
      });

    if (
      $filter('filter')(EditorService.currentFacts, {
        characters: { character_id: '!!' },
      }).length
    ) {
      $scope.$watch(
        function () {
          return EditorService.assetStatus.length;
        },
        function () {
          if (EditorService.assetStatus.length > 1) {
            $q.all(EditorService.assetStatus).finally(function () {
              EditorService.assetStatus = [];
              EditorService.assetsLoaded = true;
            });
          }
        }
      );
    } else {
      EditorService.assetsLoaded = true;
    }

    function saveEditorSession() {
      Picmonics.saveEditorSession(
        { card_id: EditorService.currentCard.card_id },
        { time_spent: Math.round((Date.now() - start) / 1000) }
      );
    }

    window.onbeforeunload = function () {
      if (EditorService.history.length > 1) {
        return 'You have unsaved changes!';
      }
      saveEditorSession();
    };

    $scope.preventEnter = function ($event) {
      if ($event.keyCode == 13 && !angular.element($event.target).is('textarea')) {
        $event.preventDefault();
      }
    };

    $scope.froalaOptions = {
      key: 'LB-22encg1C-8xqA2wzA-13==',
      autosave: false,
      inlineMode: false,
      theme: 'custom',
      height: '94%',
      buttons: [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'align',
        'insertOrderedList',
        'insertUnorderedList',
        'fontFamily',
        'fontSize',
        'color',
        'subscript',
        'superscript',
        'insertImage',
        'save',
      ],
      events: {
        onPaste: function (e, editor, pasteString) {
          var tmp = pasteString
            .replace(/<[^>]+font-weight:700;.+?>(.*?)<\/.*?>/g, '<b>$1</b>')
            .replace(/<strong.*?>/g, '<strong>')
            .replace(/<br.*?>/g, '<br />')
            .replace(/<(?!((b>)|\/b>|strong>|\/strong>|br \/>)).*?>/g, '');
          return tmp;
        },
      },
      spellcheck: true,
    };

    // Determine if the user has seen the editor before
    $scope.userHasEdited = true;

    $scope.import = function () {
      $modal.open({
        templateUrl: '/templates/modals/import-characters.html',
        windowClass: 'below-nav',
        backdropClass: 'below-nav',
        size: 'md',
        controller: [
          '$scope',
          'Upload',
          function ($scope, Upload) {
            $scope.facts = [];
            data = $filter('orderBy')(
              $filter('filter')(EditorService.currentFacts, {
                header: '0',
              }),
              ['order', 'fact_id']
            );
            for (var i in data) {
              if (isFinite(i)) {
                $scope.facts.push(parseInt(i, 10));
              }
            }
            $scope.upload = function ($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
              if (!$newFiles) {
                return false;
              }
              $scope.valid = true;
              var facts = angular.copy($scope.facts);
              $scope.characters = [];
              $scope.background_file = null;
              $scope.files = $files;
              for (var x in $files) {
                if ($files[x].name.toLowerCase().indexOf('bb') === 0) {
                  $scope.background_file = $files[x];
                  Upload.imageDimensions($scope.background_file).then(function (dimensions) {
                    $scope.mainDimensions = dimensions;
                    for (var i in $files) {
                      if ($files[i].name.indexOf('tc') === 0) {
                        $scope.topic_character_image = $files[i];
                      } else if ($files[i].name.toLowerCase().indexOf('bb') !== 0) {
                        (function (cntr) {
                          Upload.imageDimensions($files[cntr]).then(function (dimensions) {
                            var values = $files[cntr].name.match(/s?(\d*).*_(-?\d+)_(-?\d+)_(-?\d+)/);
                            if (values[1] && $scope.facts.indexOf(parseInt(values[1], 10)) === -1) {
                              delete $files[cntr];
                              return;
                            }

                            $scope.characters.push({
                              file: $files[cntr],
                              width: (dimensions.width / $scope.mainDimensions.width) * 100 + '%',
                              height: (dimensions.height / $scope.mainDimensions.height) * 100 + '%',
                              top: Math.max(0, (values[3] / $scope.mainDimensions.height) * 100) + '%',
                              left: Math.max(0, (values[2] / $scope.mainDimensions.width) * 100) + '%',
                              z: values[4] + 2,
                            });
                          });
                        })(i);
                      }
                    }
                    if (!$scope.topic_character_image) {
                      for (i in $files) {
                        if ($files[i].name.indexOf('00') === 0) {
                          $scope.topic_character_image = $files[i];
                        }
                      }
                    }
                  });
                } else {
                  if (isFinite($files[x].name[0])) {
                    if ($scope.facts.indexOf(parseInt($files[x].name, 10)) === -1) {
                      alert(
                        'fact number ' + parseInt($files[x].name, 10) + " doesn't exist and it's image will be ignored!"
                      );
                    }
                    var index = facts.indexOf(parseInt($files[x].name, 10));
                    if (index !== -1) {
                      facts.splice(index, 1);
                    }
                  }
                }
              }
              if (!$scope.background_file) {
                alert('No background layer uploaded');
              }
              if (facts.length) {
                alert('Missing charaters for facts: ' + facts);
              }
            };

            $scope.save = function () {
              if ($scope.loading) {
                return;
              }
              $scope.loading = true;
              $scope.uploading = true;
              $scope.progress = 0;
              EditorService.saveCard().then(function () {
                var upload = Upload.upload({
                  url: '/api/v2/picmonics/' + EditorService.currentCard.card_id + '/assets',
                  data: { assets: $scope.files },
                });

                upload.then(
                  function (resp) {
                    alert('assets uploaded successfully');
                    $scope.uploading = false;
                    window.location.reload();
                  },
                  function (resp) {
                    alert('There was an error');
                    $scope.uploading = false;
                    window.location.reload();
                  },
                  function (evt) {
                    $scope.uploading = true;
                    $scope.progress = evt.loaded;
                    $scope.max = evt.total;
                    if ($scope.progress == $scope.max) {
                      $scope.uploading = false;
                    }
                  }
                );
              });
            };
          },
        ],
      });
    };

    $scope.uploadAudio = function (type, $file) {
      var t = type;
      type = type === 'educational' ? 'Educational' : 'Story';
      if ($file) {
        var update = false;
        if (type == 'Story') {
          $scope.uploadingStory = true;
          $scope.storyfile = $file;
          update = $scope.updateStory;
        } else {
          $scope.uploadingEducational = true;
          $scope.educationalfile = $file;
          update = $scope.updateEducational;
        }

        var data = {
          file: $file,
          type: type,
          update: 1,
          card_id: EditorService.currentCard.card_id,
          sync_timings: 0,
        };

        var upload = Upload.upload({
          url: '/api/v2/audio/upload',
          data: data,
        });

        upload.then(
          function (res) {
            EditorService.audioLoaded = true;
            if (res.data.metadata.markers && res.data.metadata.markers.length) {
              facts = $filter('filter')(EditorService.currentFacts, {
                entity_type_id: 2,
                header: '!1',
              });

              for (var x = 0; x < res.data.metadata.markers.length && x < facts.length; x++) {
                if (!facts[x].audio) {
                  facts[x].audio = {};
                }

                if (!facts[x].audio[t]) {
                  facts[x].audio[t] = {};
                }
                facts[x].audio[t].start = res.data.metadata.markers[x].start;
                facts[x].audio[t].end = res.data.metadata.markers[x].end;
              }
            }
            if (type == 'Story') {
              $scope.uploadingStory = false;
            } else {
              $scope.uploadingEducational = false;
            }
            EditorService.currentCard[t.toLowerCase() + '_uploaded'] = 1;
            if (EditorService.currentCard.remove_audio) {
              delete EditorService.currentCard.remove_audio[t];
            }
          },
          function (res) {
            toaster.error('Error uploading audio file. Please try again.');
          },
          function (e) {
            if (type == 'Story') {
              $scope.uploadingStory = true;
            } else {
              $scope.uploadingEducational = true;
            }
            $scope.progress = e.loaded;
            $scope.max = e.total;
          }
        );
      }

      return false;
    };

    $scope.$on('$destroy', function () {
      window.onbeforeunload = null;
      saveEditorSession();
      EditorService.backgroundScrollCheckOff();
    });
  },
]);
